import BaseApi from '@core/api/model';

export class RestrictedPanelApi extends BaseApi {
    static resource = 'panels';

    get endpoints() {
        return {
            ...super.endpoints,
            replacePanelOffers: this.replacePanelOffers.bind(this)
        };
    }

    async replacePanelOffers(id, offers = [], config = {}) {
        return this.put({ id, offers }, config);
    }
}

export default RestrictedPanelApi;
